import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { BeneficiaryDetailsCurrency } from 'types/beneficiaries'
import { ContactFiatInstrumentFormData } from '../schemas/contactFiatInstrumentSchema'

type UseFormFieldOptionsProps = {
  formValues: ContactFiatInstrumentFormData
}

export const useFormFieldOptions = ({ formValues }: UseFormFieldOptionsProps) => {
  const { t } = useTranslation()

  const getAccountTypeOption = (leftText: string, value: string) => ({
    leftText,
    value,
  })

  const accountTypeOptions = useMemo(() => {
    switch (formValues?.currency) {
      case BeneficiaryDetailsCurrency.USD:
        return [
          getAccountTypeOption(t('Checking'), 'CHECKING'),
          getAccountTypeOption(t('Savings'), 'SAVINGS'),
        ]
      case BeneficiaryDetailsCurrency.ZAR:
        return [
          getAccountTypeOption(t('cheque'), 'CHEQUE'),
          getAccountTypeOption(t('savings'), 'SAVINGS'),
          getAccountTypeOption(t('transmission'), 'TRANSMISSION'),
        ]
      default:
        return
    }
  }, [formValues?.currency])

  return useMemo(() => {
    return {
      accountTypeOptions,
    }
  }, [accountTypeOptions])
}
